// extracted by mini-css-extract-plugin
module.exports = {"light":"contexts_light__XYqGa","dark":"contexts_dark__MyDpm"};